import axios from 'axios';
import { COMMENT_LIKE_UNLIKE } from './types';
import api from '../../../utils/api';

export default {
  async likeUnlike(_, post) {
    await axios(api.postsLikeUnlike.create(post));
  },
  async CommentlikeUnlike({ commit }, data) {
    commit(COMMENT_LIKE_UNLIKE, { add: data.add, url: data.comment });
    await axios(api.postsLikeUnlike.create({ comment: data.comment }));
  },
};
